import { useEffect, useState } from 'react';
import { Button, Col, Form, notification, Row, Upload, message } from 'antd';
import { countryService, profileService } from '../../../services';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { MdOutlineWatchLater } from "react-icons/md";
import { GoShieldCheck, GoDotFill } from "react-icons/go";
import { LuPackageSearch, LuCalendarDays, LuSave } from "react-icons/lu";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { FaRegUserCircle } from "react-icons/fa";
import { FiCopy, FiFileText, FiPhone, FiEdit3 } from "react-icons/fi";
import MaterialLikeTextArea from '../../../components/MaterialLikeTextArea ';
import MaterialLikeInput from '../../../components/MaterialLikeInput';
import MaterialLikeSelect from '../../../components/MaterialLikeSelect';
import { RxCross2 } from "react-icons/rx";
import { HiCheck, HiOutlineMail } from "react-icons/hi";
import { CiLocationOn } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/slices/userSlice";
import dayjs from "dayjs"
import { ROLE, ROLES } from '../../../constants';
import { RiLockPasswordLine } from 'react-icons/ri';
import ChangePasswordModal from './ChangePasswordModal';

function EditProfile() {

    const [form] = Form.useForm();

    const [changePassModal, setChangePassModal] = useState(false);

    const [submitLoad, setSubmitLoad] = useState(false);
    const [countries, setCountries] = useState([]);
    const [data, setData] = useState({})
    const [fileList, setFileList] = useState([]);
    const [removedImage, setRemovedImage] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [copied, setCopied] = useState(false);
    const role = localStorage.getItem("role")
    const dispatch = useDispatch();

    const onFinish = async (values) => {
        setSubmitLoad(true);

        const formData = new FormData();

        Object.entries(values).forEach(([key, value]) => {
            formData.append(key, value);
        });

        if (fileList.length > 0 && fileList[0].originFileObj) {
            const fileItem = fileList[0];
            const file =
                fileItem.originFileObj ||
                null;

            if (file) {
                formData.append('profile_image', file);
            }
        }

        if (removedImage) {
            formData.append('remove_profile_image', removedImage)
        }

        formData.append('_method', 'PUT');

        const response = await profileService.updateProfile(0, formData);

        setSubmitLoad(false);

        if (response.success) {
            dispatch(setUser(response.data));
            notification.success({
                message: "Success",
                description: "Profile updated successfully!",
                placement: "topRight",
            });
            await loadData(); // ✅ reloads latest data from backend
            setIsEditing(false);
        } else {
            notification.error({
                message: "Error",
                description: `Error: ${response.message}`,
                placement: "topRight",
            });
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.error("Failed:", errorInfo);
    };

    const handleCopy = () => {
        if (data.id) {
            navigator.clipboard.writeText(data.id);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // reset after 1.5s
        }
    }

    const loadData = async () => {
        const hide = message.loading('Fetching Data...', 0);
        const response = await profileService.fetchLoggedUser()
        hide()
        if (response?.success ?? false) {
            setData(response.data)
            form.setFieldsValue({
                ...response.data,
                // secondary_email: response.data.secondary_email || "",
            })
            if (response.data.profile_image) {
                setFileList([
                    {
                        uid: '-1',
                        name: 'profile_image.jpg',
                        status: 'done',
                        url: response.data.profile_image,
                    },
                ]);
            } else {
                setFileList([]);
            }
        }
    }

    const loadCountries = async () => {
        const response = await countryService.countryGet()
        if (response?.success) {
            setCountries(response.data);
        }
    }

    const handleDelete = () => {
        if (fileList[0].url) {
            setRemovedImage(fileList[0].url)
        }
        setFileList([])
    }

    const handleChange = ({ fileList: newFileList }) => {
        const file = newFileList[0]?.originFileObj;
        const isImage = file?.type.startsWith('image/');

        if (!isImage) {
            message.error('Only image files are allowed!');
            return;
        }

        setFileList(newFileList);
    };

    const cardData = [
        { icon: <LuPackageSearch style={{ fontSize: 20, color: "#6A7282" }} />, heading: "Vehicles", value: data?.no_of_vehicles || 0, },
        { icon: <LiaFileInvoiceDollarSolid style={{ fontSize: 20, color: "#6A7282" }} />, heading: "Invoices amount", value: data?.invoice?.total_amount || 0, },
        { icon: <LuCalendarDays style={{ fontSize: 20, color: "#6A7282" }} />, heading: "Appointments", value: data?.no_of_appointments || 0, }
    ]

    useEffect(() => {
        loadData()
        loadCountries()
    }, []);

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
        <>
            <div className='flex items-center justify-between mb-3'>
                <div>
                    <h1 className='text-lg m-0 p-0 font-semibold'>{role === ROLES.CUSTOMER ? "Customer" : role === ROLES.ADMIN ? "Admin" : "Staff"} Profile</h1>
                    <p className='p-0 m-0 text-[#6A7282]'>View first, edit when needed</p>
                </div>
                <div className='flex gap-3'>
                    {isEditing ? (
                        <>
                            <Button
                                // htmlType="submit"
                                type="primary"
                                onClick={() => form.submit()} // ✅ triggers onFinish manually

                                loading={submitLoad}
                                icon={<LuSave style={{ fontSize: 18 }} />}
                            >
                                Save Changes
                            </Button>
                            <Button
                                icon={<RxCross2 style={{ fontSize: 18 }} />}
                                onClick={() => {
                                    form.setFieldsValue(data); // 🔁 reset values
                                    setIsEditing(false)
                                }}
                            >
                                Cancel
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button type="primary" icon={<RiLockPasswordLine style={{ fontSize: 18 }} />} onClick={() => setChangePassModal(true)}>
                                Change Password
                            </Button>

                            <Button type="primary" htmlType="button" icon={<FiEdit3 style={{ fontSize: 18 }} />} onClick={() => setIsEditing(true)}>
                                Edit Profile
                            </Button>
                        </>
                    )}
                </div>
            </div>

            <Form
                layout='horizontal'
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Row gutter={[16, 16]} style={{ backgroundColor: "#FFFFFF", padding: '25px', borderRadius: '16px', }} className='border'>
                    <Col span={24} className='flex gap-0'>

                        {isEditing && fileList.length > 0 && (

                            <CloseCircleOutlined
                                className="absolute top-2 text-white bg-black bg-opacity-50 rounded-full text-lg cursor-pointer z-20"
                                onClick={handleDelete}
                                title="Delete"
                            />
                        )}
                        <div className="relative group w-[130px] h-[104px] rounded-full overflow-hidden">
                            <Upload
                                showUploadList={false}
                                listType="picture-circle"
                                beforeUpload={() => false}
                                onChange={handleChange}
                                maxCount={1}
                                disabled={!isEditing}   // ✅ ONLY ADD THIS LINE
                                className="absolute inset-0 z-10"
                            >

                                {fileList.length > 0 ? (
                                    <>
                                        <img
                                            src={fileList[0].url || URL.createObjectURL(fileList[0].originFileObj || null)}
                                            alt="avatar"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: '50%',
                                            }}
                                        // className="transition-opacity duration-300 group-hover:opacity-10"
                                        />
                                        {isEditing &&
                                            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                                {uploadButton}
                                            </div>
                                        }

                                    </>
                                ) : (
                                    uploadButton
                                )}
                                {/* <CloseCircleOutlined
                                    className="absolute top-1 right-1 text-white bg-black bg-opacity-50 rounded-full text-lg cursor-pointer z-100"
                                    onClick={() => setFileList([])}
                                    title="Delete"
                                /> */}
                            </Upload>
                        </div >

                        <div className='flex  mt-6 justify-between w-full'>
                            <div className=' flex flex-col'>
                                <h1 className='text-2xl font-bold p-0 m-0'>{data.name}</h1>
                                <h1 className='p-0 m-0 text-base'>{data.email}</h1>
                            </div>
                            <div className=' flex flex-col gap-1' >
                                <p className='flex items-center gap-2 text-[#949596] text-base m-0 p-0'> <MdOutlineWatchLater />Last Login, {data.last_logged_in}</p>
                                <p className='flex items-center gap-2 text-[#949596] text-base m-0 p-0'><GoShieldCheck /> IP, 144.48.128.231</p>
                            </div>
                        </div>
                    </Col >
                </Row >

                <div className='my-4 flex w-full gap-5'>
                    {role === ROLES.ADMIN ? null :
                        cardData.map((dta, index) => (
                            <div className='flex w-full bg-white items-center gap-3 p-4 border rounded-xl   '>
                                <div className='shadow-xl flex items-center justify-center bg-white p-3 rounded-xl'>
                                    {dta.icon}
                                </div>
                                <div className='flex flex-col gap-1'>
                                    <p className='m-0 p-0 text-[#6A7282] text-xs'>{dta.heading}</p>
                                    <p className='m-0 p-0 text-lg font-semibold'>{dta.value}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className='flex gap-5'>
                    <div className={`flex flex-col ${role === ROLES.ADMIN ? "w-full" : "w-[68%]"} bg-white items-center gap-3 p-4 border rounded-xl`}>
                        <div className='flex gap-2 items-center justify-start w-full'>
                            <span><FaRegUserCircle style={{ fontSize: 16, color: "#6A7282" }} /></span>
                            <span className='text-base font-semibold'>Profile Meta</span>
                        </div>
                        <div className='w-full flex'>
                            <div className='flex flex-col w-full'>
                                <span className='text-[#6A7282] text-sm'>UID</span>
                                <div className='flex  items-center gap-2'>
                                    <span className='font-semibold text-sm'>{data.id}</span>
                                    <button
                                        type="button"  // 👈 Prevent form submission
                                        onClick={handleCopy}
                                        className="p-1 rounded-md hover:bg-gray-100 active:scale-90 transition relative group"
                                    >
                                        {copied ? (
                                            <HiCheck size={16} className="text-green-500" />
                                        ) : (
                                            <FiCopy size={16} className="text-gray-500" />
                                        )}
                                        <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-[10px] text-white bg-black px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                                            Copy
                                        </span>
                                    </button>
                                </div>

                            </div>
                            <div className='flex flex-col w-full'>
                                <span className='text-[#6A7282] text-sm'>Sign up time</span>
                                <span className='font-semibold text-sm'>{dayjs(data.created_at).format("MMM D, YYYY h:mm A")}</span>
                            </div>
                        </div>
                        {role === ROLES.ADMIN ? null :
                            <div className='w-full flex'>
                                <div className='flex flex-col w-full'>
                                    <span className='text-[#6A7282] text-sm'>Last updated</span>
                                    <span className='font-semibold text-sm'>{dayjs(data.updated_at).format("MMM D, YYYY h:mm A")}
                                    </span>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <span className='text-[#6A7282] text-sm'>Parent customer</span>
                                    <span className='font-semibold text-sm'>{data.parent_customer || '-'}</span>
                                </div>
                            </div>
                        }
                    </div>

                    {role === ROLES.ADMIN ? null :
                        <div className='flex flex-col w-[33%] bg-white items-center gap-3 p-4 border rounded-xl   '>
                            <div className='flex gap-2 items-center justify-start w-full'>
                                <span><LuCalendarDays style={{ fontSize: 16, color: "#6A7282" }} /></span>
                                <span className='text-base font-semibold'>Contract</span>
                                <span className='text-[9px] bg-[#F3F4F6] px-2 py-1 rounded-full font-medium'>Admin set</span>
                            </div>
                            <div className='w-full flex'>
                                <div className='flex flex-col w-full'>
                                    <span className='text-[#6A7282] text-sm'>Start date</span>
                                    <span className='font-semibold text-sm'>{data?.contract_start_date}</span>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <span className='text-[#6A7282] text-sm'>End date</span>
                                    <span className='font-semibold text-sm'>{data?.contract_end_date}</span>
                                </div>
                            </div>
                            <div className='w-full flex'>
                                <div className='flex flex-col w-full'>
                                    <span className='text-[#6A7282] text-sm'>Total days</span>
                                    <span className='font-semibold text-sm'>{data?.contract_days}</span>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <span className='text-[#6A7282] text-sm'>Charge per day</span>
                                    <span className='font-semibold text-sm'>${data?.contract_charges}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                {role === ROLES.ADMIN ? null :
                    <>
                        <div className='flex gap-5 mt-5'>
                            <div className='flex flex-col w-[68%] bg-white gap-3 p-4 border rounded-xl' >
                                {isEditing ? (
                                    <Form.Item
                                        name="note"
                                        className='w-full'
                                        style={{ marginBottom: 0, height: "120px" }}
                                    >
                                        <MaterialLikeTextArea
                                            label="Note"
                                            rows={6}
                                            value={form.getFieldValue("note")}
                                            onChange={(e) => form.setFieldValue("note", e.target.value)}
                                        />
                                    </Form.Item>
                                ) : (
                                    <div>
                                        <div className='flex items-center gap-1 '>
                                            <FiFileText style={{ fontSize: 15, color: "#6A7282" }} />
                                            <span className='text-sm font-semibold '>
                                                Note
                                            </span>
                                        </div>
                                        <p className='mt-2'>{data.note || "This is a long note to demonstrate the See more toggle. Add any internal remarks here. Customer prefers morning calls and invoices grouped monthly."} </p>
                                    </div>
                                )}
                            </div>

                            <div className='flex flex-col w-[33%] bg-white items-center gap-3 p-4 border rounded-xl   '>
                                <div className='flex gap-2 items-center justify-start w-full'>
                                    <span><LuCalendarDays style={{ fontSize: 16, color: "#6A7282" }} /></span>
                                    <span className='text-base font-semibold'>Recent activity</span>
                                    <span className='text-[9px] bg-[#F3F4F6] px-2 py-1 rounded-full font-medium'>Dummy data</span>
                                </div>
                                <div className='w-full flex flex-col gap-3'>
                                    <div className='flex gap-1'>
                                        <GoDotFill style={{ color: "#D1D5DC", fontSize: 16 }} />
                                        <div className='flex flex-col w-full'>
                                            <span className='text-sm font-semibold '>
                                                Profile viewed, <span className='text-[#6A7282] text-xs'>1 min ago</span></span>
                                            <span className='text-xs text-[#6A7282]'>2024-01-01</span>
                                        </div>
                                    </div>
                                    <div className='flex gap-1'>
                                        <GoDotFill style={{ color: "#D1D5DC", fontSize: 16 }} />
                                        <div className='flex flex-col w-full'>
                                            <span className='text-sm font-semibold'>Invoice generated,<span className='text-[#6A7282] text-xs'> 2 days ago</span></span>
                                            <span className='text-xs text-[#6A7282]'>#INV-2025-0926</span>
                                        </div>
                                    </div>
                                    <div className='flex gap-1'>
                                        <GoDotFill style={{ color: "#D1D5DC", fontSize: 16 }} />
                                        <div className='flex flex-col w-full'>
                                            <span className='text-sm font-semibold'>Login, <span className='text-[#6A7282] text-xs'> 3 days ago</span></span>
                                            <span className='text-xs text-[#6A7282]'>2025-09-28 02:39:19, IP 144.48.128.231</span>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className='flex  flex-col w-full '>

                            <div className='flex w-full gap-4'>

                                <div className='flex flex-col h-auto w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >

                                    {isEditing ? (
                                        <Form.Item
                                            name="name"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeInput
                                                label="Name"
                                                value={form.getFieldValue("name")}
                                                onChange={(e) => form.setFieldValue("name", e.target.value)}
                                            />
                                        </Form.Item>
                                    ) : (
                                        <div className="flex gap-2">
                                            <FaRegUserCircle style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">Name</span>
                                                <span className="text-base font-semibold ">{data.name}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >

                                    {isEditing ? (

                                        <Form.Item
                                            name="email"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeInput
                                                label="Email"
                                                value={form.getFieldValue("email")}
                                                onChange={(e) => form.setFieldValue("email", e.target.value)}
                                            />
                                        </Form.Item>
                                    ) : (
                                        <div className="flex gap-2">
                                            <HiOutlineMail style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">Email</span>
                                                <span className="text-base font-semibold ">{data.email}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='flex w-full gap-4'>

                                <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >

                                    {isEditing ? (
                                        <Form.Item
                                            name="address"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeInput
                                                label="Address"
                                                value={form.getFieldValue("address")}
                                                onChange={(e) => form.setFieldValue("address", e.target.value)}
                                            />
                                        </Form.Item>
                                    ) : (
                                        <div className="flex gap-2">
                                            <CiLocationOn style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">Address</span>
                                                <span className="text-base font-semibold ">{data.address}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >

                                    {isEditing ? (

                                        <Form.Item
                                            name="phone"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeInput
                                                label="Phone"
                                                value={form.getFieldValue("phone")}
                                                onChange={(e) => form.setFieldValue("phone", e.target.value)}
                                            />
                                        </Form.Item>) : (
                                        <div className="flex gap-2">
                                            <FiPhone style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">Phone</span>
                                                <span className="text-base font-semibold ">{data.phone}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>

                            <div className='flex w-full gap-4'>

                                <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >

                                    {isEditing ? (
                                        <Form.Item
                                            name="town"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeInput
                                                label="Town"
                                                value={form.getFieldValue("town")}
                                                onChange={(e) => form.setFieldValue("town", e.target.value)}
                                            />
                                        </Form.Item>
                                    ) : (
                                        <div className="flex gap-2">
                                            <CiLocationOn style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">Town</span>
                                                <span className="text-base font-semibold ">{data.town}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >
                                    {isEditing ? (
                                        <Form.Item
                                            name="city"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeInput
                                                label="City"
                                                value={form.getFieldValue("city")}
                                                onChange={(e) => form.setFieldValue("city", e.target.value)}
                                            />
                                        </Form.Item>
                                    ) : (
                                        <div className="flex gap-2">
                                            <CiLocationOn style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">City</span>
                                                <span className="text-base font-semibold ">{data.city}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='flex w-full gap-4'>

                                <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl  mt-5' >

                                    {isEditing ? (
                                        <Form.Item
                                            name="country"
                                            className='w-full'
                                            style={{ marginBottom: 0, height: "50px" }}
                                        >
                                            <MaterialLikeSelect
                                                label="Country"
                                                value={form.getFieldValue("country")}
                                                onChange={(value) => form.setFieldValue("country", value)}
                                                options={countries.map((country) => ({
                                                    id: country.id,
                                                    value: country.iso_code,
                                                    label: country.name
                                                }))}
                                            />
                                        </Form.Item>
                                    ) : (
                                        <div className="flex gap-2">
                                            <CiLocationOn style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                            <div>
                                                <span className="text-sm text-gray-600  block">Country</span>
                                                <span className="text-base font-semibold ">{data.country_name}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {(isEditing || data?.secondary_email) && (
                                    <div className='flex flex-col w-full bg-white gap-3 p-4 border rounded-3xl mt-5'>
                                        {isEditing ? (
                                            <Form.Item
                                                name="secondary_email"
                                                className='w-full'
                                                style={{ marginBottom: 0, height: "50px" }}
                                            >
                                                <MaterialLikeInput
                                                    label="Secondary Email"
                                                    value={form.getFieldValue("secondary_email")}
                                                    onChange={(e) => form.setFieldValue("secondary_email", e.target.value)}
                                                />
                                            </Form.Item>
                                        ) : (
                                            <div className="flex gap-2">
                                                <CiLocationOn style={{ fontSize: 16, color: "#6A7282", marginTop: 1 }} />
                                                <div>
                                                    <span className="text-sm text-gray-600  block">Secondary Email</span>
                                                    <span className="text-base font-semibold ">{data.secondary_email}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                            </div>


                        </div>
                    </>

                }

            </Form >

            <ChangePasswordModal open={changePassModal} setOpen={setChangePassModal} />
        </>

    );
}

export default EditProfile;
